import { QueryKey } from '@tanstack/react-query';
import queryClient from './query-client';
import { useQueryWithCallback } from './use-query-with-callback';

/**
 * Map of query keys use by the react-query hooks.
 */
export const queryKeys = {
    allWorkflowInstances: 'allWorkflowInstances',
    accountSync: 'accountSync',
    checkinEntries: 'checkinEntries',
    checkinEntriesLatest: 'checkinEntriesLatest',
    circles: 'circles',
    circleById: 'circleById',
    countries: 'countries',
    dependentPartnerById: 'dependentPartnerById',
    deviceConsent: 'deviceConsent',
    recommendations: 'recommendations',
    referrals: 'referrals',
    workflowByDefnId: 'workflowByDefnId',
    workflowByType: 'workflowByType',
    workflowNextStepByDefnId: 'workflowNextStepByDefnId',
    packByPackClass: 'packByPackClass',
    packsByPackClass: 'packsByPackClass',
    recipientPrograms: 'recipientPrograms',
    forYouRecommendations: 'forYouRecommendations',
    clinicalPacksByPackClass: 'clinicalPacksByPackClasses',
    mediaCookies: 'mediaCookies',
    conditions: 'conditions',
    dailies: 'dailies',
    dailiesIndexes: 'dailiesIndexes',
    sleepStories: 'sleepStories',
    discoverSections: 'discoverSections',
    goals: 'goals',
    guide: 'guide',
    invitations: 'invitations',
    invitationByCode: 'invitationByCode',
    invitationById: 'invitationById',
    mostRecentSponsorship: 'mostRecentSponsorship',
    notificationPreferences: 'notificationPreferences',
    notificationUser: 'notificationUser',
    poll: 'poll',
    pollSubmission: 'pollSubmission',
    productsByUserId: 'userProducts',
    program: 'program',
    programs: 'programs',
    publicNarrators: 'publicNarrators',
    publicProgram: 'publicProgram',
    publicBrandingPartnerConfig: 'publicBrandingPartnerConfig',
    partnerByCode: 'partnerByCode',
    partnerById: 'partnerById',
    partnerEligibility: 'partnerEligibility',
    refreshAccessToken: 'refreshAccessToken',
    recentAndFavoriteGuides: 'recentAndFavoriteGuides',
    tosCohortConsent: 'tosCohortConsent',
    tokenData: 'tokenData',
    videoBackground: 'videoBackground',
    healthSummary: 'healthSummary',
    healthSummarySignedUrl: 'healthSummarySignedUrl',
    previousRegistrationFlow: 'previousRegistrationFlow',
    search: 'search',
    searchTrending: 'searchTrending',
    searchTypeahead: 'searchTypeahead',
    searchResults: 'searchResults',
};

export * from '@tanstack/react-query';

export const invalidateQueryKey = (key: QueryKey) => {
    return queryClient.invalidateQueries({ queryKey: key });
};

export { queryClient, useQueryWithCallback };
